import "core-js/modules/es.array.join";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { activityTimeManager } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewPage],
  props: {
    propsData: Object
  },
  data: function data() {
    return {
      dialogShow: false,
      serverID: [],
      paramsData: {
        env_id: '',
        actID: '',
        server_id: ''
      },
      rules: {
        startTime: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        endTime: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {//  this.serverListYJ = this.propsData.serverList
  },
  methods: {
    open: function open(data) {
      this.serverListYJ = this.propsData.serverList;
      console.log("data===", data);
      this.paramsData.actID = data.actID;
      this.paramsData.env_id = this.propsData.env_id; // this.paramsData.server_id = this.propsData.server_id;

      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
      this.clearData();
    },
    clearData: function clearData() {
      this.paramsData = {
        env_id: '',
        actID: '',
        server_id: '',
        op: "reset"
      }, this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      var params = {
        env_id: this.paramsData.env_id,
        actID: this.paramsData.actID,
        op: "reset",
        server_id: this.paramsData.server_id.join(",")
      };
      activityTimeManager(params).then(function (res) {
        if (res.status == 200) {
          _this.$message({
            message: _this.$t('operationSuccess'),
            type: 'success'
          });

          _this.dialogShow = false;

          _this.$emit('update');
        }
      });
    }
  }
};